import calories_svg from "../../assets/caloriesSvg.svg"
import perfromance_svg from "../../assets/performanceSvg.svg"
import session_svg from "../../assets/sessionSvg.svg"

const mockYourMetrics = [
    {
        "heading": "Total Sessions",
        "svg": session_svg,
        "info": "16/20",
        "info_unit": "",
        "last_update": "3m"
    },
    {
        "heading": "Calories Burned",
        "svg": calories_svg,
        "info": "105",
        "info_unit": "KKal",
        "last_update": "1m"
    },
    {
        "heading": "Total Sessions",
        "svg": perfromance_svg,
        "info": "105",
        "info_unit": "bpm",
        "last_update": "3m"
    },
];

// Modify the login function to match the email and password against the mock data
export const getYourMetric = () => {
    return mockYourMetrics;
};
